import type { ContentObjectView, KudoContentObjectDetail, KudoContentObjectList } from 'models';
import { Col, Row } from 'ui';
import { ContentObjectFooter } from '../../content-object-footer';
import { ContentObjectHeader } from '../../content-object-header';
import { ContentObjectPreview } from '../../content-object-preview';
import { useCreateActions } from './hooks';
import { KudoContentObjectBody } from './kudo-content-object-body';

type P = {
  item: KudoContentObjectDetail | KudoContentObjectList;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const KudoContentObject = ({ item, onShowComments, view }: P) => {
  const { actions, contexts, editModal } = useCreateActions({ item, view });

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} view={view} />
      </Col>

      <Col span={24}>
        <KudoContentObjectBody item={item} showReadMore={view !== 'other'} />
      </Col>

      <Col span={24}>
        <ContentObjectFooter
          item={item}
          onShowComments={onShowComments}
          preview={<ContentObjectPreview item={item} view="other" />}
          view={view}
        />
      </Col>
      {contexts}
      {editModal}
    </Row>
  );
};

export default KudoContentObject;
